import type { CaptureResult } from "posthog-js";

export const EQUIPMENT_CAP_EXPERIMENT_KEY = "equipment-cap-5-v1";
export const CONSUMER_OFFER_VERSION = "equipment-cap-5-v1";
const FEATURE_PROPERTY = `$feature/${EQUIPMENT_CAP_EXPERIMENT_KEY}`;
type ConfirmedOffer = { subject: string; variant: "control" | "cap5"; assignmentId: string };
let confirmed: ConfirmedOffer | null = null;

export function setConfirmedOfferAnalytics(offer: ConfirmedOffer | null): void {
  confirmed = offer;
}

/** PostHog's browser flag can rebucket after identify; the saved server offer
 * owns experiment attribution. Apply this after the SDK merges properties,
 * and omit assignment entirely for pending, excluded or foreign identities. */
export function applyConfirmedOfferAnalytics(event: CaptureResult | null): CaptureResult | null {
  if (!event) return event;
  const properties = { ...event.properties };
  delete properties[FEATURE_PROPERTY];
  if (confirmed && properties.distinct_id === confirmed.subject) {
    properties[FEATURE_PROPERTY] = confirmed.variant;
    properties.offer_assignment_id = confirmed.assignmentId;
  }
  return { ...event, properties };
}
